import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  border-bottom: 2px solid #ccc;
  padding: 8px;
  text-align: left;
`;

export const Td = styled.td`
  padding: 8px;
  border-bottom: 1px solid #eee;
`;

export const TotalHighlight = styled.span`
  font-weight: bold;
  color: #2c7a7b;
`;